import { apiHost } from "./utils/api-host-resolver";
import { API_PATH, TOKEN } from "./constants";

export const enableFFForAccount: (name: string, accountId: string) => Promise<any> =
    async (name: string, accountId: string) => {
        const token = localStorage.getItem(TOKEN)
        return await fetch(`${apiHost}${API_PATH}/ff/connect`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ name, accountId })
        })
            .then(resp => resp.json())
            .catch(e => console.log(e))
    }